// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle-wrapper {
  animation: rotate 2s linear infinite;
  z-index: 2;
  width: 40px;
  height: 40px;
}
.circle-wrapper circle {
  stroke: #c1cace;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared/Loading/Loading.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,eAAA;EACA,qBAAA;EACA,yCAAA;AACJ;;AAGA;EACE;IACE,yBAAA;EAAF;AACF;AAGA;EACE;IACE,wBAAA;IACA,oBAAA;EADF;EAGA;IACE,yBAAA;IACA,sBAAA;EADF;EAGA;IACE,yBAAA;IACA,uBAAA;EADF;AACF","sourcesContent":[".circle-wrapper {\n  animation: rotate 2s linear infinite;\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n\n  & circle {\n    stroke: #c1cace;\n    stroke-linecap: round;\n    animation: dash 1.5s ease-in-out infinite;\n  }\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
